// validates the ?rd= return URL a satellite app passes through the SSO login
// redirect: only https URLs on the apex domain or its subdomains are allowed,
// everything else (foreign hosts, other protocols, malformed input) is dropped
export function getSafeRedirect(rd: string | null, apexDomain = 'kelmiashkin.ru'): string | null {
  if (!rd) return null
  try {
    const url = new URL(rd)
    if (url.protocol !== 'https:') return null
    if (url.hostname !== apexDomain && !url.hostname.endsWith('.' + apexDomain)) return null
    return url.toString()
  } catch {
    return null
  }
}
